// URL參數
const search = window.location.search.slice(1)
let Params = function () {
    var _self = this
    search.replace(/([^=]*)=([^&]*)&?/g, function (str, key, val) {
        _self[key] = decodeURIComponent(val).replace(/</g, "&lt;").replace(/>/g, "&gt;");
    })
}
Params.prototype.toString = function () {
    return search;
}

export const params = new Params()

// 設備平臺判斷
var ua = navigator.userAgent.toLowerCase()

export const platform = {
    isMobile: /(iphone|ipod|ipad|ios|android|nokia|blackberry|webos|webos|webmate|bada|lg|ucweb)/i.test(ua),
    isIos: /(iphone|ipod|ipad|ios)/i.test(ua),
    isAndroid: /(android)/i.test(ua),
    isWeiXin: /micromessenger/i.test(ua),
    isQQBrowser: /qqbrowser/i.test(ua)
}

//复制时添加版权信息
import info from '@/data/copyInfo'
export const copy = el => {
    //el 需添加版权信息的元素
    el.addEventListener('copy', function (event) {
        // clipboardData 对象是为通过编辑菜单、快捷菜单和快捷键执行的编辑操作所保留的，也就是你复制或者剪切内容
        let clipboardData = event.clipboardData || window.clipboardData;
        // 如果未复制或者未剪切，则return出去
        if (!clipboardData) {
            return;
        }
        // Selection 对象，表示用户选择的文本范围或光标的当前位置。
        // 声明一个变量接收 -- 用户输入的剪切或者复制的文本转化为字符串
        let text = window.getSelection().toString();
        if (text) {
            // 如果文本存在，首先取消文本的默认事件
            event.preventDefault();
            // 通过调用常clipboardData对象的setData(format, data)方法；来设置相关文本
            // setData(format, data);参数
            // format
            // 一个DOMString 表示要添加到 drag object的拖动数据的类型。
            // data
            // 一个 DOMString表示要添加到 drag object的数据。
            clipboardData.setData('text/plain', text + `\n${info.data}(${location.href})`);
        }
    });

}

// cookie 操作
export const cookie = {
    set: function (key, val, day) {
        var date = new Date()
        if (day) {
            date.setTime(date.getTime() + day * 24 * 3600 * 1000); // 格式化日期
        }
        document.cookie = key + "=" + val + (day ? ";path=/;expires=" + date.toGMTString() : '') //設置cookie
    },
    get: function (key) {
        var getCookie = document.cookie.replace(/[ ]/g, ""), // 獲取cookie，並且將獲得的cookie格式化，去掉空格字符
            arrCookie = getCookie.split(";"), // 將獲得的cookie以"分號"為標識 將cookie保存到arrCookie的數組中
            match // 聲明變量
        for (var i = 0; i < arrCookie.length; i++) {
            arrCookie[i] = arrCookie[i].replace('=', ' ')
            var arr = arrCookie[i].split(" ");
            if (key == arr[0]) {
                match = arr[1];
                break;
            }
        }
        return match
    },
    delete: function (key) {
        var date = new Date()
        date.setTime(date.getTime() - 10000); // 過期處理
        document.cookie = key + "=v; expires =" + date.toGMTString();
    }
}

// 隨機字符串
export const randomID = () => {
    var t = ((new Date() / 1) + "").split(""),
        tmp = "",
        ran = 0;
    for (var i = t.length; i > 0; i--) {
        ran = Math.floor(Math.random() * 3) + 1;
        if (t[i]) {
            if (t[i] != 0) {
                if (ran == 1) {
                    tmp += String.fromCharCode(64 + parseInt(t[i]));
                } else if (ran == 2) {
                    tmp += String.fromCharCode(64 + parseInt(t[i])).toLowerCase();
                } else {
                    tmp += t[i]
                }
            } else {
                tmp += t[i];
            }
        }
    }
    return tmp;
}

// 日期格式化
var plusZero = num => num > 9 ? num : `0${num}`
export const timeFormat = (t, format = 'yyyy-mm-dd') => {
    // 接受format为 yyyy mm dd hh MM ss 任意精简字段，连接符自定义
    if (t) {
        if (!Number(t)) {
            // 防ios
            if (typeof (t) == 'string' && /-/.test(t)) {
                t = t.replace(/-/g, "/")
            }

            if (!/:/.test(t)) {
                t += ' 00:00:00'
            }
        }
        t = new Date(t)
        let y = t.getFullYear(), // 年份
            m = plusZero(t.getMonth() + 1), // 月份
            d = plusZero(t.getDate()), // 日期

            h = plusZero(t.getHours()), // 小时
            M = plusZero(t.getMinutes()), // 分钟
            s = plusZero(t.getSeconds()) // 秒

        let temp = format
        temp = temp.replace(/yyyy/g, y)
        temp = temp.replace(/mm/g, m)
        temp = temp.replace(/dd/g, d)
        temp = temp.replace(/hh/g, h)
        temp = temp.replace(/MM/g, M)
        temp = temp.replace(/ss/g, s)

        return temp
    } else {
        return '--/--/--'
    }
}

//防抖
export const debounce = (fn, delay) => {
    let timer = null //借助闭包
    return function () {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(fn, delay) // 简化写法
    }
}